document.addEventListener('DOMContentLoaded', function() {
  // Anchor link toggle (mobile only)
  const anchorNavToggles = document.querySelectorAll('.js-toggle-anchor-nav');
  for (const anchorNavToggle of [...anchorNavToggles]) {
    const anchorNav = anchorNavToggle.closest('.js-anchor-nav');
    const anchorNavContainer = anchorNav.querySelector('.js-anchor-nav-container');
    const anchorNavList = anchorNav.querySelector('.js-anchor-nav-list');

    anchorNavToggle.addEventListener('click', (e) => {
      e.preventDefault();

      if (anchorNav.hasAttribute('data-open-by-default')) {
        anchorNav.removeAttribute('data-open-by-default');
        anchorNavContainer.style.maxHeight = '';
        anchorNavContainer.classList.remove('shadow-nav');
      } else if (anchorNav.hasAttribute('data-open')) {
        anchorNav.removeAttribute('data-open');
        anchorNavContainer.style.maxHeight = '';
        anchorNavContainer.classList.remove('shadow-nav');
      } else {
        anchorNav.setAttribute('data-open', 'true');
        anchorNavContainer.style.maxHeight = `${anchorNavList.scrollHeight}px`;
        anchorNavContainer.classList.add('shadow-nav');
      }
    });
  }

  // Select all anchor links
  const anchorLinks = document.querySelectorAll('.js-anchor-link');

  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // Defensive: Only handle left click or keyboard activation
      if (e.type === 'click' && e.button !== 0) return;

      const targetId = this.getAttribute('href');
      if (!targetId || targetId === '#') return;

      let targetElement;
      try {
        targetElement = document.querySelector(targetId);
      } catch (err) {
        // Invalid selector, do nothing
        return;
      }
      if (!targetElement) return;

      e.preventDefault();
      // Add hash to URL without scrolling (so scrollIntoView still works)
      if (history.pushState) {
        history.pushState(null, '', targetId);
      } else {
        location.hash = targetId;
      }

      // Smooth scroll to target
      try {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } catch (err) {
        // scrollIntoView may fail in some browsers
        targetElement.scrollIntoView(true);
      }

      // Close mobile anchor nav if it's open
      const anchorNav = this.closest('.js-anchor-nav');
      if (anchorNav) {
        const anchorNavContainer = anchorNav.querySelector('.js-anchor-nav-container');
        anchorNav.removeAttribute('data-open');
        if (anchorNavContainer) {
          anchorNavContainer.style.maxHeight = '';
          anchorNavContainer.classList.remove('shadow-nav');
        }
      }
    });
  });

  // Update active anchor link on scroll
  // Function to check if element is in viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.5 &&
      rect.bottom >= 0
    );
  }

  // Function to update selected anchor link
  // This function has several possible points where JS could break due to missing/null elements or logic errors.
  // Let's rewrite it with defensive checks and comments on possible break points.

  function updateSelectedAnchor() {
    const anchorLinks = document.querySelectorAll('.js-anchor-link');
    if (!anchorLinks || anchorLinks.length === 0) return;

    let translateDistance = 0;

    // Defensive: get the first anchor link and its target section
    const firstLink = anchorLinks[0];
    if (!firstLink) return;

    const firstHref = firstLink.getAttribute('href');
    if (!firstHref || firstHref === '#') return;

    let firstSection;
    try {
      firstSection = document.querySelector(firstHref);
    } catch (err) {
      // Invalid selector, abort
      return;
    }
    if (!firstSection) return;

    anchorLinks.forEach(link => {
      const targetId = link.getAttribute('href');
      if (!targetId || targetId === '#') return;

      const anchorNav = link.closest('.js-anchor-nav');
      if (!anchorNav) return;

      const anchorNavList = anchorNav.querySelector('.js-anchor-nav-list');
      if (!anchorNavList) return;

      let targetElement;
      try {
        targetElement = document.querySelector(targetId);
      } catch (err) {
        // Invalid selector, skip
        return;
      }
      if (!targetElement) return;

      if (isInViewport(targetElement)) {
        link.setAttribute('data-selected', 'true');
        // firstVisibleLink = link; // This variable is not declared anywhere and will throw ReferenceError
        // Remove or declare firstVisibleLink if needed, or just remove this line

        const links = anchorNavList.querySelectorAll('.js-anchor-link');
        const selectedIndex = Array.from(links).indexOf(link);

        if (window.innerWidth < 1024) {
          if (selectedIndex > 0) {
            translateDistance = selectedIndex * -66; // 66px is the height of each nav item
            anchorNavList.style.transform = `translateY(${translateDistance}px)`;
          } else {
            anchorNavList.style.transform = '';
          }
        } else {
          anchorNavList.style.transform = '';
        }
      } else {
        link.removeAttribute('data-selected');
      }
    });

    // Select the first link when first section is visible
    if (window.scrollY <= firstSection.offsetTop) {
      firstLink.setAttribute('data-selected', 'true');
      const anchorNav = firstLink.closest('.js-anchor-nav');
      if (anchorNav) {
        const anchorNavList = anchorNav.querySelector('.js-anchor-nav-list');
        if (anchorNavList) {
          anchorNavList.style.transform = '';
        }
      }
    }
  }

  // Add scroll event listener
  window.addEventListener('scroll', updateSelectedAnchor);

  // Initial check on page load
  updateSelectedAnchor();
});

/*
 * Sale Banner
*/

const promoSlider = document.querySelector('.js-promo-slider');

if(promoSlider) {
  const promoFlkty = new Flickity(promoSlider, {
    cellAlign: 'center',
    contain: true,
    autoPlay: 5000,
    wrapAround: true,
    cellSelector: '.js-slide',
    prevNextButtons: false
  })
}

// Countdown

const countdown = document.querySelector('.js-promo-countdown');

if (countdown) {
  const dateStr = countdown.dataset.date; // e.g., '2023-12-31'
  const timeStr = countdown.dataset.time; // e.g., '12:34'

  // Split the date and time strings to extract components
  const [month, day, year] = dateStr.split('-').map(Number);
  const [hours, minutes] = timeStr.split(':').map(Number);

  // Create a Date object for the target date and time in the local time zone (GMT-7 for Vancouver)
  const targetDate = new Date(year, month - 1, day, hours, minutes, 0);

  // Function to pad numbers with leading zeros
  function pad(number) {
    return number.toString().padStart(2, '0');
  }

  // Function to update the countdown
  function updateCountdown() {
    const now = new Date();
    const difference = targetDate - now;

    if (difference <= 0) {
      clearInterval(interval);
      return;
    }

    const days = pad(Math.floor(difference / (1000 * 60 * 60 * 24)));
    const hours = pad(Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    const minutes = pad(Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)));
    const seconds = pad(Math.floor((difference % (1000 * 60)) / 1000));

    countdown.querySelector('.js-days').innerText = days;
    countdown.querySelector('.js-hours').innerText = hours;
    countdown.querySelector('.js-minutes').innerText = minutes;
    countdown.querySelector('.js-seconds').innerText = seconds;
  }

  // Update the countdown every second
  const interval = setInterval(updateCountdown, 1000);
  updateCountdown(); // Initial call to display the countdown immediately
}

class SaleBanner extends HTMLElement {
  constructor() {
    super();
    this.saleBannerCloseBtn = this.querySelector('.js-sale-banner-close');
    if(this.saleBannerCloseBtn) {
      this.saleBannerCloseBtn.addEventListener('click', this.onBannerClose.bind(this));
    }
  }
  connectedCallback() {
    const promoBannerSession = sessionStorage.getItem('omd:promoBannerIsOpen');
    window.addEventListener('resize', this.handleResize);

    /**
     * If session storage item is undefined, define as true.
     */
    if (!promoBannerSession) {
      sessionStorage.setItem('omd:promoBannerIsOpen', 'true');
    }

    /**
     * If the session state is 'false', hide the banner.
     * Else, like on a fresh load:
     * Set the session state to 'true', and set the banner style display to block.
    */

    if (promoBannerSession === 'false') {
      this.classList.add('hidden');
      document.querySelector('.js-header-spacer').style.marginTop = '0px';
    } else {

      sessionStorage.setItem('omd:promoBannerIsOpen', 'true');
      this.classList.remove('hidden');
      document.querySelector('.js-header-spacer').style.marginTop = this.querySelector('.js-sale-banner').offsetHeight + 'px';
      if(document.querySelector('.product__media-wrapper')){
      document.querySelector('.product__media-wrapper').style.top = '15rem';
      }
      window.scrollTo(0,0);
    };
  }

  /**
   * Handles resizing of the window, and resetting the header spacer margin-top amount.
   */
  handleResize = (event) => {
    document.querySelector('.js-header-spacer').style.marginTop = this.querySelector('.js-sale-banner').offsetHeight + 'px';
  }

  /**
  * Event listener for the close button.
  * OnClick:
  * 1. Set display property of the wrapper to 'none'.
  * 2. Set the session variable 'promo_state' to 'false'.
  */
  onBannerClose = (event) => {
    document.dispatchEvent(new Event("promoBanner:hidden"));
    if (sessionStorage.getItem('omd:promoBannerIsOpen') === 'true') {
      this.classList.add('hidden');
      document.querySelector('.js-header-spacer').style.marginTop = '0px';
      sessionStorage.setItem('omd:promoBannerIsOpen', 'false');
    }
  }
}

customElements.define('sale-banner', SaleBanner);

// Klaviyo tracking
var _learnq = _learnq || [];
$('.shopify-payment-button__button').on('click', function () {
  _learnq.push(['track', 'Added to Cart', item]);
});

const queryStringParameters = new URLSearchParams(window.location.search);
const landerItemProperty = queryStringParameters.get('landerItemProperty');
landerItemProperty && localStorage.setItem('omd:landerItemProperty', landerItemProperty);

// Accordion
// h5.js-accordion + div + hr
const accordions = document.getElementsByClassName('js-accordion');
function accordionClicked(el) {
  if (!el.classList.contains('js-accordion-mobile') || window.matchMedia('(max-width: 768px)').matches) {
    const caret = el.querySelector('.js-icon-caret');
    const panel = el.nextElementSibling;
    const panelMaxHeight = panel.style.maxHeight;
    let outerAccordionHeader = null;
    let outerAccordionContent = null;
    let outerAccordionContentHeight = 0;

    // If it's a nested accordion, find the outer accordion
    if (el.classList.contains('js-inner-accordion')) {
      // Grab the parent element
      outerAccordionContent = el.parentElement;
      // Grab the parent's previous sibling
      outerAccordionHeader = el.parentElement.previousElementSibling;
      // If it's not an accordion, just act like it's not a nested accordion
      if (!outerAccordionHeader.classList.contains('js-accordion')) {
        console.error('Could not find outer accordion');
        outerAccordionContent = null;
        outerAccordionHeader = null;
      }
    }

    if (outerAccordionContent) {
      outerAccordionContentHeight = outerAccordionContent.scrollHeight;
    }
    if (panelMaxHeight == '0px' || !panelMaxHeight) {
      // Open the accordion
      panel.style.maxHeight = panel.scrollHeight + 'px';
      caret.style.transform = 'rotate(180deg)';

      el.setAttribute('open', true);
      el.setAttribute('aria-expanded', true);
      if (outerAccordionContent) {
        outerAccordionContentHeight += panel.scrollHeight;
        outerAccordionContent.style.maxHeight = outerAccordionContentHeight + 'px';
      }
    } else {
      // Close the accordion
      panel.style.maxHeight = '0px';
      caret.style.transform = 'rotate(0deg)';

      el.removeAttribute('open');
      el.setAttribute('aria-expanded', false);
      if (outerAccordionContent) {
        outerAccordionContentHeight -= panel.scrollHeight;
        outerAccordionContent.style.maxHeight = outerAccordionContentHeight + 'px';
      }
    }
  }
}
document.addEventListener('DOMContentLoaded', function() {
  for (let i = 0; i < accordions.length; i++) {
    const currAccordion = accordions[i];
    // Open by default if set to
    if (currAccordion.getAttribute('data-accordion-default-open') === 'true') {
      accordionClicked(currAccordion);
    }
    // Hook up click event
    currAccordion.addEventListener('click', function() {
      accordionClicked(this);
    });
  }
});
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.lastScrollY = window.scrollY;
    this.navElement = null;
    this.navHeight = 0;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this); // Ensure proper binding
    this.anchorNav = null;
  }

  connectedCallback() {
    this.navElement = document.querySelector('.js-nav');
    this.anchorNav = document.querySelector('.js-anchor-nav');
    this.headerElement = document.querySelector('.js-header');

    if (!this.navElement) {
      console.error('Required elements not found');
      return;
    }

    // Set initial nav height
    this.navHeight = this.navElement.offsetHeight;

    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);

    // Add promo banner hidden listener
    document.addEventListener('promoBanner:hidden', () => {
      // Delay the resize call to ensure accurate height calculation
      setTimeout(this.handleResize, 50); // Adjust delay as necessary
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('promoBanner:hidden', this.handleResize);
  }

  handleScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY === 0) {
      // At the top
      this.classList.remove('is-fixed', 'is-visible');
      this.navElement.style.top = '';
    } else if (currentScrollY > this.navHeight) {
      // Scrolled past navigation height
      this.classList.add('is-fixed');
      this.navElement.style.top = `-${Math.ceil(this.navHeight)}px`;

      if (currentScrollY < this.lastScrollY) {
        // Scrolling up
        if (!this.classList.contains('is-visible')) {
          this.classList.add('is-visible');
          document.dispatchEvent(new Event('nav:visible'));
        }
      } else {
        // Scrolling down
        if (this.classList.contains('is-visible')) {
          this.classList.remove('is-visible');
          document.dispatchEvent(new Event('nav:hidden'));
        }
      }
    }

    this.lastScrollY = currentScrollY; // Update last scroll position
  }

  handleResize() {
    // Force layout recalculation and update nav height
    this.navHeight = this.navElement.offsetHeight;

    if (this.classList.contains('is-fixed')) {
      this.navElement.style.top = `-${Math.ceil(this.navHeight)}px`;
    }
  }
}
customElements.define('sticky-header', StickyHeader);



class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    this.header = this.querySelector('#header-drawer');
    this.overlay = this.querySelector('.js-overlay');
    this.querySelectorAll('.js-toggle-nav').forEach(navToggle => navToggle.addEventListener('click', this.onToggleNav.bind(this)));

    this.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const isOpen = this.header.style.left === '0px';
    if(!isOpen) return;

    this.closeMenuDrawer(event, this.header);
  }

  onToggleNav(event) {
    const toggleElement = event.currentTarget;
    const isOpen = this.header.style.left === '0px';

    if (isOpen) event.preventDefault();
    isOpen ? this.closeMenuDrawer(event, toggleElement) : this.openMenuDrawer(toggleElement);
  }

  openMenuDrawer(summaryElement) {
    document.body.style.overflow = 'hidden';
    this.header.style.setProperty('left', '0');
    this.overlay.classList.remove('invisible');
    this.overlay.style.setProperty('opacity', '0.3');
    document.body.style.overflow = 'hidden';
    trapFocus(this.header, summaryElement);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      document.body.style.overflow = 'initial';
      var headerWidth = this.header.offsetWidth;

      this.header.style.setProperty('left', `-${headerWidth}px`);
      this.overlay.style.setProperty('opacity', '0');
      this.overlay.classList.add('invisible');
      document.body.style.overflow = 'auto';
      removeTrapFocus(elementToFocus);
    }
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    detailsElement.style.display = "none";
  }
}

customElements.define('header-drawer', HeaderDrawer);

$(() => {
  let labels = $('.form__label--placeholder');

  labels.each(function(){
      let label = $(this);
      let input = label.siblings('input, select');

      if(!input.val() || !input.val().length){
        label.removeClass('form__label--active')
      } else {
        label.addClass('form__label--active')
      }

      input.on('focus', function(){
        label.addClass('form__label--active')
      })

      input.on('blur change reset', function(){
        if(!input.val().length){
          label.removeClass('form__label--active')
        } else {
          label.addClass('form__label--active')
        }
      })
  })
})


// Move any code we're using above this line
// TODO: remove any unused code below this line
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.js-slider-current');
    this.pageTotalElement = this.querySelector('.js-slider-total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    // if (this.isSlideVisible(this.sliderItemsToShow[0])) {
    //   this.prevButton.setAttribute('disabled', 'disabled');
    // } else {
    //   this.prevButton.removeAttribute('disabled');
    // }

    // if (this.isSlideVisible(this.sliderLastItem)) {
    //   this.nextButton.setAttribute('disabled', 'disabled');
    // } else {
    //   this.nextButton.removeAttribute('disabled');
    // }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }


  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateBundleOptionVariants();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    
    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const mediaGalleryMobile = document.querySelector(`#gallery-mobile-${ this.dataset.section } #MediaGallery-${this.dataset.section}`);

    if(mediaGalleryMobile) {
      let activeMedia =  mediaGalleryMobile.querySelector('.is-active')
    
      this.updateSliderHeight(activeMedia)

      mediaGalleryMobile.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }
    
    if(mediaGallery) {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }
    
    
    
    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  
  
  updateSliderHeight(mediaItem) {
    const resizeHandler = () => {
      const isActive = mediaItem.classList.contains('is-active');
      const parentElement = mediaItem.parentElement;
      if (isActive) {
        const imageElement = mediaItem.querySelector('img');
        let imageHeight = imageElement.clientHeight;
        setTimeout(function(){
          parentElement.style.height = imageHeight + 'px';
        }, 500)
      } else {
        parentElement.style.height = 'initial';
      }
    };
  
    // Call the resize handler initially
    
    resizeHandler();
    
  
    // Attach the resize event listener using event delegation
    window.addEventListener('resize', resizeHandler);
  }
  
  updateBundleOptionVariants(){
    let bundleVariant = $('input[name="items[0][id]"]')
    bundleVariant.val(this.currentVariant.id)
  }
  
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.fmData.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if(!button) {
      return;
    }
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();

        // Variant data is in snippets/variant-data.liquid
        this.variantData = JSON.parse(document.getElementById('variant-data').textContent);
        this.addEventListener('change', this.onVariantChange.bind(this));

        // Update master id on load
        this.updateMasterId();

        // Update Geo UX on load
        updateGeoUX(this.currentVariant);
    }

    onVariantChange(event) {
        super.onVariantChange(event);
        const selectedRadio = event.target;
        this.updateMasterId();
        this.updateSelectedLabels(selectedRadio);
        this.updateSelectedPrices(selectedRadio);
        this.updateSliders();
        this.updateVariantImage();

        updateGeoUX(this.currentVariant);
    }

    updateMasterId() {

      const selectedOptions = Array.from(this.querySelectorAll('fieldset')).map(fieldset => {
        return Array.from(fieldset.querySelectorAll('input:checked')).map(input => input.value);
      }).flat();

      // Find the matching variant based on selected options
      this.currentVariant = this.variantData.find(variant => {
        return selectedOptions.every((option, index) => variant[`option${index + 1}`] === option);
      });

    }

    updateSelectedLabels(selectedOption) {
        if (!selectedOption || !selectedOption.value) {
            console.warn("No selected option found or it does not have a value.");
            return;
        }

        const group = selectedOption.dataset.group;
        const selectedValue = selectedOption.value;
        const isLimitedEdition = selectedOption.dataset.limited === "true";

        // Determine the correct label span based on limited edition status
        const regularLabelSpan = document.querySelectorAll(`.js-variant-name[data-group="${group}"]`);
        const limitedLabelSpan = document.querySelectorAll(`.js-limited-variant-name[data-group="${group}"]`);

        // Update the appropriate label and clear the other
        if (isLimitedEdition && limitedLabelSpan) {
          limitedLabelSpan.forEach(span => {
            span.textContent = selectedValue;
          })

          if(regularLabelSpan) {
            regularLabelSpan.forEach(span => {
              span.textContent = "";
            })
          }
          
        } else if (regularLabelSpan) {
            regularLabelSpan.forEach(span => {
              span.textContent = selectedValue;
            })

            if(limitedLabelSpan) {
              limitedLabelSpan.forEach(span => {
                span.textContent = "";
              })
            }
        }
    }

    updateSelectedPrices(selectedOption) {
      if (!this.currentVariant) {
        console.warn("No matching variant found for selected options.");
        return;
      }

      let purchaseOptions = document.querySelectorAll('.js-purchase-option');

      purchaseOptions.forEach((option, i) => {
        let index = i + 1;

        let singlePrice = `$${(this.currentVariant.price / 100).toFixed(2)}`;
        let singleCompare = this.currentVariant.compare_at_price 
          ? `$${(this.currentVariant.compare_at_price / 100).toFixed(2)}` 
          : "";

        let bundlePrice = this.currentVariant.metafields.custom[`total_bundle_price_${index}`] ? `$${(this.currentVariant.metafields.custom[`total_bundle_price_${index}`] / 100).toFixed(2)}` : '';
        let bundleCompare = this.currentVariant.metafields.custom[`compare_at_bundle_price_${index}`] ? `$${(this.currentVariant.metafields.custom[`compare_at_bundle_price_${index}`] / 100).toFixed(2)}` : '';

        option.querySelectorAll('.js-single-price').forEach(elem => {
          elem.textContent = singlePrice.includes('USD') ? `${singlePrice} USD` : singlePrice;
        });

        option.querySelectorAll('.js-bundle-price').forEach(elem => {
          if (bundlePrice) elem.textContent = bundlePrice.includes('USD') ? `${bundlePrice} USD` : bundlePrice;
        });

        option.querySelectorAll('.js-single-compareat-price').forEach(elem => {
          elem.textContent = singleCompare.includes('USD') ? `${singleCompare} USD` : singleCompare;
        });

        option.querySelectorAll('.js-bundle-compareat-price').forEach(elem => {
          if (bundleCompare) elem.textContent = bundleCompare.includes('USD') ? `${bundleCompare} USD` : bundleCompare;
        });
      })

    }

    updateVariantImage() {
      document.querySelectorAll('.js-variant-image').forEach(image => {
        image.setAttribute('src', this.currentVariant.image)
        image.setAttribute('data-src', this.currentVariant.image);
      })
    }

    updateSliders(selectedOption) {
      const mainSlider = Flickity.data('.js-carousel');
      const mainSliderNav = Flickity.data('.js-carousel-nav')
      const mobileSlider = Flickity.data('.js-carousel-main-mobile');

      // let mainSlides = $('.js-carousel').find(`.carousel-cell[data-color]`)
      // let navSlides = $('.js-carousel-nav').find(`.carousel-cell[data-color]`)

      if(!mainSlider) {
        return;
      }

      const productVariants = document.querySelectorAll('.carousel-main .product__media-item--variant')
      const productVariantsThumbnails = document.querySelectorAll('.carousel-nav .thumbnail-list_item--variant')
      const mobileProductVariants = document.querySelectorAll('.carousel-main-mobile .product__media-item--variant')

      let changed = false;

      productVariants.forEach((p) => {
        if(p.dataset.variant == this.currentVariant.id) {
          changed = true;
          productVariants.forEach(p => {
            p.style.display = 'none'
          })
          p.style.display = 'block'
        }
      })

      mobileProductVariants.forEach((p) => {
        if(p.dataset.variant == this.currentVariant.id) {
          changed = true;
          mobileProductVariants.forEach(p => {
            p.style.display = 'none'
          })
          p.style.display = 'block'
        }
      })

      productVariantsThumbnails.forEach((p) => {
        if(p.dataset.variant == this.currentVariant.id){
          changed = true;
          productVariantsThumbnails.forEach(p => {
            p.style.display = 'none'
          })
          p.style.display = 'block'
        }
      }) 

      let mainSlides = this.currentVariant.options.flatMap(option => {
        return Array.from(document.querySelectorAll(`.js-carousel .carousel-cell[data-color="${option}"]`));
      })

      let navSlides = this.currentVariant.options.flatMap(option => {
        return Array.from(document.querySelectorAll(`.js-carousel-nav .carousel-cell[data-color="${option}"]`));
      })

      let mobileSlides = this.currentVariant.options.flatMap(option => {
        return Array.from(document.querySelectorAll(`.js-carousel-main-mobile .carousel-cell[data-color="${option}"]`));
      })

      if(mainSlides.length) {
        mainSlider.remove(mainSlides)
        mainSliderNav.remove(navSlides)
        mobileSlider.remove(mobileSlides)

        mainSlider.insert(mainSlides, 1)
        mainSliderNav.insert(navSlides, 1)
        mobileSlider.insert(mobileSlides, 1)
      }

      if(changed || mainSlides.length) {
        mainSlider.select( 0, false, true );
        mobileSlider.select( 0, false, true );
        mainSliderNav.select( 0, false, true );
      }
      
    }
}

customElements.define('variant-radios', VariantRadios);

// Global updateGeoUX function that can be called independently
function updateGeoUX(currentVariant = null) {
  console.log('updateGeoUX', currentVariant);
  const atcButtons = document.querySelectorAll('.js-atc-button');
  const waitlistButtons = document.querySelectorAll('.js-waitlist-button'); 
  const waitlistInputs = document.querySelectorAll('.js-waitlist-input');

  const preorderComponent = document.querySelectorAll('.js-preorder-component');
  const preorderInput = document.querySelectorAll('.js-preorder-property-input');
  const preorderMessage = document.querySelectorAll('.js-preorder-message');

  // If no variant is provided, try to get the first available variant from variant-data
  if (!currentVariant) {
    const variantDataElement = document.getElementById('variant-data');
    if (variantDataElement) {
      try {
        const variantData = JSON.parse(variantDataElement.textContent);
        currentVariant = variantData[0]; // Use first variant as default
      } catch (e) {
        console.warn('Could not parse variant data for updateGeoUX');
        return;
      }
    } else {
      console.warn('No variant data found for updateGeoUX');
      return;
    }
  }

  const usPreorderMessage = currentVariant.preorder_message_us;
  const caPreorderMessage = currentVariant.preorder_message_ca;

  // Data in snippets/variant-data.liquid
  const disableAtcUS = currentVariant.disable_atc_for_us;
  const disableAtcCA = currentVariant.disable_atc_for_ca;
  const usWaitlistId = String(currentVariant.waitlist_id);
  const caWaitlistId = String(currentVariant.ca_waitlist_id);

  const showPreorderUS = currentVariant.show_preorder_messaging_us;
  const showPreorderCA = currentVariant.show_preorder_messaging_ca;

  function showPreorderMessagingUS() {
    preorderComponent.forEach(component => {
      component.classList.remove('hidden');
    })

    preorderInput.forEach(input => {
      input.setAttribute('name', `properties[Pre-order]`);
      input.setAttribute('value', usPreorderMessage);
    });

    preorderMessage.forEach(message => {
      message.textContent = usPreorderMessage;
    }); 
  }

  function showPreorderMessagingCA() {
    preorderComponent.forEach(component => {
      component.classList.remove('hidden');
    })

    preorderInput.forEach(input => {
      input.setAttribute('name', `properties[Pre-order]`);
      input.setAttribute('value', caPreorderMessage);
    });

    preorderMessage.forEach(message => {
      message.textContent = caPreorderMessage;
    });
  }

  function hidePreorderMessaging() {
    preorderComponent.forEach(component => {
      component.classList.add('hidden');
    })

    preorderInput.forEach(input => {
      input.removeAttribute('name');
      input.value = '';
    });

    preorderMessage.forEach(message => {
      message.textContent = '';
    });
  }

  function showWaitlistButtons(){
    waitlistButtons.forEach(button => {
      button.classList.remove('hidden');
    })

    atcButtons.forEach(button => {
      button.classList.add('hidden');
    })
  }

  function showATCButtons(){
    atcButtons.forEach(button => {
      button.classList.remove('hidden');
    })

    waitlistButtons.forEach(button => {
      button.classList.add('hidden');
    })
  }

  function updateWaitlistId(waitlistId){
    waitlistInputs.forEach(input => {
      input.setAttribute('data-form-id', waitlistId)
    })
  }

  function updateByGeo(json) {
    if (json.country_code == "US") {
      if (disableAtcUS) {
        showWaitlistButtons()

        if (usWaitlistId) {
          updateWaitlistId(usWaitlistId)
        }
      } else {
        showATCButtons()
      }

      if (showPreorderUS) {
        showPreorderMessagingUS()
      } else {
        hidePreorderMessaging()
      }
    } else if (json.country_code == "CA") {
      if (disableAtcCA) {
        showWaitlistButtons()

        if (caWaitlistId) {
          updateWaitlistId(caWaitlistId)
        }
      } else {
        showATCButtons()
      }

      if (showPreorderCA) {
        showPreorderMessagingCA()
      } else {
        hidePreorderMessaging()
      }
    }
  }

  /**
  * Creates and appends a script element to load the GeoJS geolocation service
  * @see {@link https://www.geojs.io/docs/v1/endpoints/geo/} GeoJS API documentation
  */

  const runGeolocationScript = () => {
    const geoscript = document.createElement('script');
    geoscript.src = "https://get.geojs.io/v1/ip/geo.js";

    let geoscriptMarkup = document.createDocumentFragment();
    geoscriptMarkup.appendChild(geoscript);

    document.head.appendChild(geoscriptMarkup);
  }

  /**
  * Initialize
  */
  runGeolocationScript();

  window.geoip = function (json) {
    if (!Shopify.designMode) {
  
      if (window.fmData) { 
        window.fmData.customerGeo = json; 
      }
  
      if (window.fmData.customerGeo) {
        updateByGeo(window.fmData.customerGeo); 
      }
    }
  }
}

// Video modal controls for .js-play-on-modal-open videos
function initializeVideoModalControls() {
  // Function to play videos when modal opens
  function playModalVideos(modal) {
    // Look for videos with the class, but also check if the class is applied to the video element itself
    let videos = [];
    
    // First, try to find video elements with the class directly
    const directVideos = modal.querySelectorAll('video.js-play-on-modal-open');
    videos = videos.concat(Array.from(directVideos));
    
    // Also look for any element with the class that might contain a video
    const elementsWithClass = modal.querySelectorAll('.js-play-on-modal-open');
    elementsWithClass.forEach(element => {
      // If the element itself is a video, add it
      if (element.tagName === 'VIDEO' && !videos.includes(element)) {
        videos.push(element);
      }
      // If the element contains a video, add the video
      const nestedVideo = element.querySelector('video');
      if (nestedVideo && !videos.includes(nestedVideo)) {
        videos.push(nestedVideo);
      }
    });
    
    // Fallback: if no videos found with the class, look for any videos in the modal
    // This helps with cases where the video_tag filter might not apply the class correctly
    if (videos.length === 0) {
      const allVideos = modal.querySelectorAll('video');
      
      // Check if any of these videos have attributes that suggest they should autoplay
      allVideos.forEach(video => {
        if (video.hasAttribute('controls') || video.classList.contains('js-play-on-modal-open')) {
          videos.push(video);
        }
      });
    }
    
    // Remove duplicates
    videos = [...new Set(videos)];
    
    videos.forEach(video => {
      if (video.tagName === 'VIDEO') {
        // Ensure video is unmuted and play
        video.muted = false;
        video.volume = 1.0;
        
        // Add a small delay to ensure modal is fully visible
        setTimeout(() => {
          video.play().catch(error => {
            console.warn('Could not autoplay video:', error);
            // Fallback: show play button or handle autoplay restriction
          });
        }, 100);
      }
    });
  }

  // Function to pause videos when modal closes
  function pauseModalVideos(modal) {
    // Use the same logic to find videos
    let videos = [];
    
    const directVideos = modal.querySelectorAll('video.js-play-on-modal-open');
    videos = videos.concat(Array.from(directVideos));
    
    const elementsWithClass = modal.querySelectorAll('.js-play-on-modal-open');
    elementsWithClass.forEach(element => {
      if (element.tagName === 'VIDEO' && !videos.includes(element)) {
        videos.push(element);
      }
      const nestedVideo = element.querySelector('video');
      if (nestedVideo && !videos.includes(nestedVideo)) {
        videos.push(nestedVideo);
      }
    });
    
    videos = [...new Set(videos)];
    
    videos.forEach(video => {
      if (video.tagName === 'VIDEO') {
        video.pause();
        video.currentTime = 0; // Reset to beginning
      }
    });
  }

  // Listen for modal open events from various modal systems
  if (window.EventBus) {
    // FM Events modal system
    window.EventBus.on('modalOpened', (modal) => {
      playModalVideos(modal);
    });

    window.EventBus.on('modalClosed', (modal) => {
      pauseModalVideos(modal);
    });
  }

  // Listen for details-modal open/close events
  document.addEventListener('click', (event) => {
    const detailsModal = event.target.closest('details-modal');
    if (detailsModal) {
      const details = detailsModal.querySelector('details');
      if (details) {
        // Check if modal is opening
        if (details.hasAttribute('open')) {
          // Use MutationObserver to detect when details attribute changes
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                if (details.hasAttribute('open')) {
                  playModalVideos(detailsModal);
                } else {
                  pauseModalVideos(detailsModal);
                }
                observer.disconnect();
              }
            });
          });
          
          observer.observe(details, { attributes: true });
        }
      }
    }
  });

  // Listen for Bootstrap modal events (if using tw-elements)
  document.addEventListener('show.bs.modal', (event) => {
    const modal = event.target;
    playModalVideos(modal);
  });

  document.addEventListener('hide.bs.modal', (event) => {
    const modal = event.target;
    pauseModalVideos(modal);
  });

  // Listen for custom modal events
  document.addEventListener('modal:open', (event) => {
    const modal = event.detail?.modal || event.target;
    playModalVideos(modal);
  });

  document.addEventListener('modal:close', (event) => {
    const modal = event.detail?.modal || event.target;
    pauseModalVideos(modal);
  });
  
  // Listen for the js-modal system's custom open event
  document.addEventListener('open', (event) => {
    if (event.detail && event.detail.modal) {
      // Find the modal element by the modal name
      const modalElement = document.querySelector(`.js-modal[data-modal="${event.detail.modal}"]`);
      if (modalElement) {
        // Add a small delay to ensure the modal is fully visible
        setTimeout(() => {
          playModalVideos(modalElement);
        }, 200);
      }
    }
  });
  
  // Also listen for when the modal--is-visible class is added (fallback)
  const modalObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const modal = mutation.target;
        if (modal.classList.contains('modal--is-visible') && modal.classList.contains('js-modal')) {
          setTimeout(() => {
            playModalVideos(modal);
          }, 200);
        } else if (!modal.classList.contains('modal--is-visible') && modal.classList.contains('js-modal')) {
          pauseModalVideos(modal);
        }
      }
    });
  });
  
  // Observe all js-modal elements for class changes
  document.querySelectorAll('.js-modal').forEach(modal => {
    modalObserver.observe(modal, { attributes: true });
  });
  
  // Also expose the function globally for manual calls if needed
  window.playModalVideos = playModalVideos;
  window.pauseModalVideos = pauseModalVideos;
  
  // Add a function to manually trigger video controls for any element
  window.triggerVideoModalControls = function(modalElement) {
    if (modalElement) {
      playModalVideos(modalElement);
    }
  };
  
  // Set up a global observer to watch for videos being added to the DOM
  // This helps catch videos that are dynamically created by the video_tag filter
  const videoObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is a video with our class
          if (node.tagName === 'VIDEO' && node.classList.contains('js-play-on-modal-open')) {
            // Check if it's in a modal context
            const modal = node.closest('[role="dialog"], details[open], .modal, [data-modal]');
            if (modal) {
              setTimeout(() => playModalVideos(modal), 100);
            }
          }
          
          // Also check if the added node contains videos with our class
          const videosInNode = node.querySelectorAll && node.querySelectorAll('video.js-play-on-modal-open');
          if (videosInNode && videosInNode.length > 0) {
            const modal = node.closest('[role="dialog"], details[open], .modal, [data-modal]');
            if (modal) {
              setTimeout(() => playModalVideos(modal), 100);
            }
          }
        }
      });
    });
  });
  
  // Start observing the entire document for video additions
  videoObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Also watch for new js-modal elements being added
  const modalElementObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is a js-modal
          if (node.classList && node.classList.contains('js-modal')) {
            modalObserver.observe(node, { attributes: true });
          }
          
          // Also check if the added node contains js-modal elements
          const modalsInNode = node.querySelectorAll && node.querySelectorAll('.js-modal');
          if (modalsInNode && modalsInNode.length > 0) {
            modalsInNode.forEach(modal => {
              modalObserver.observe(modal, { attributes: true });
            });
          }
        }
      });
    });
  });
  
  // Start observing for new modal elements
  modalElementObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Handle URL parameter-based video navigation
  function handleVideoURLParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const videoParam = urlParams.get('video');
    
    if (videoParam) {
      // Find the modal with matching URL parameter
      const targetModal = document.querySelector(`[data-url-parameter="${videoParam}"]`);
      
      if (targetModal) {
        // Find the corresponding slide in the carousel
        const slideIndex = findSlideIndexByModal(targetModal);

        console.log('Slide index found:', slideIndex);
        
        if (slideIndex !== -1) {
          // Navigate to the slide first
          navigateToVideoSlide(slideIndex);
          
          // Then open the modal after a short delay
          setTimeout(() => {
            openModalByElement(targetModal);
          }, 500);
        }
      } else {
        console.warn('No modal found for video parameter:', videoParam);
      }
    }
  }
  
  // Find the slide index by modal element
  function findSlideIndexByModal(modalElement) {
    const modalId = modalElement.getAttribute('data-modal');
    
    // Find the carousel section
    const carouselSection = document.querySelector(`.js-video-carousel`);
    if (!carouselSection) return -1;
    
    // Find all slides in the carousel
    const slides = carouselSection.querySelectorAll('.js-fm-slider-slide');
    
    // Find which slide corresponds to this modal
    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i];
      const slideModalButton = slide.querySelector(`[data-modal="${modalId}"]`);
      if (slideModalButton) {
        return i;
      }
    }
    
    return -1;
  }
  
  // Navigate FM slider to specific slide index and scroll carousel into view
  function navigateToVideoSlide(slideIndex) {
    console.log('Attempting to navigate to video slide:', slideIndex);

    const carouselSection = document.querySelector(`.js-video-carousel`);
    if (!carouselSection) {
      console.warn('No video carousel section found');
      return;
    }

    // Scroll the carousel section into view smoothly, aligning to the top
    carouselSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Get the FM Slider instance - it's attached to the carousel section
    let slider = carouselSection.fmSliderInstance;

    // If not found immediately, wait for the FM Slider to be ready
    if (!slider) {
      console.log('FM Slider instance not found immediately, waiting for ready event...');
      
      const handleSliderReady = (event) => {
        // Check if this event is for our carousel
        if (event.detail && event.detail.content && event.detail.content.slider === carouselSection) {
          console.log('FM Slider ready event received for our carousel');
          document.removeEventListener('fm-slider:ready', handleSliderReady);
          
          // Now try to navigate
          const readySlider = carouselSection.fmSliderInstance;
          if (readySlider && typeof readySlider.goTo === 'function') {
            console.log('FM Slider instance found after ready event, navigating to slide:', slideIndex);
            readySlider.goTo(slideIndex);
          } else {
            console.warn('FM Slider instance still not available after ready event');
          }
        }
      };
      
      // Listen for the FM Slider ready event
      document.addEventListener('fm-slider:ready', handleSliderReady);
      
      // Also listen for the rendered event as a fallback
      const handleSliderRendered = () => {
        console.log('FM Slider rendered event received');
        document.removeEventListener('fmSliderRendered', handleSliderRendered);
        
        // Give it a moment to attach the instance
        setTimeout(() => {
          const renderedSlider = carouselSection.fmSliderInstance;
          if (renderedSlider && typeof renderedSlider.goTo === 'function') {
            console.log('FM Slider instance found after rendered event, navigating to slide:', slideIndex);
            renderedSlider.goTo(slideIndex);
          } else {
            console.warn('FM Slider instance still not available after rendered event');
          }
        }, 100);
      };
      
      document.addEventListener('fmSliderRendered', handleSliderRendered);
      return;
    }

    if (slider && typeof slider.goTo === 'function') {
      console.log('FM Slider instance found, navigating to slide:', slideIndex);
      slider.goTo(slideIndex);
    } else {
      console.warn('FM Slider instance not found or goTo method not available');
      console.log('Slider object:', slider);
      if (slider) {
        console.log('Available methods:', Object.getOwnPropertyNames(slider));
      }
    }
  }
  
  // Open modal by element
  function openModalByElement(modalElement) {
    const modalName = modalElement.getAttribute('data-modal');
    if (modalName && window.openModal) {
      window.openModal(modalName);
    } else {
      console.warn('Could not open modal:', modalElement);
    }
  }
  
  // Run URL parameter check on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleVideoURLParameter);
  } else {
    handleVideoURLParameter();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialize video modal controls
  initializeVideoModalControls();
  
  // Select all mobile variant inputs
  const mobileVariants = document.querySelectorAll('.js-mobile-variants input[type="radio"]');

  mobileVariants.forEach((mobileRadio) => {
    mobileRadio.addEventListener('change', (event) => {
      const group = event.target.dataset.group;
      const value = event.target.value;

      // Find the corresponding hidden variant-radios button
      const desktopRadio = document.querySelector(`variant-radios input[name="${group}"][value="${value}"]`);

      if (desktopRadio && !desktopRadio.checked) {
        desktopRadio.checked = true;
        desktopRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
});

// Accordions 
document.addEventListener('DOMContentLoaded', () => {
  const accordionBtns = document.querySelectorAll('.js-accordion-toggle');

  accordionBtns.forEach((btn) => {
    const parent = btn.closest('.js-accordion-item');
    const panel = parent.querySelector('.js-accordion-panel');
    const links = panel.querySelectorAll('a,iframe,button,input,video');

    disableLinks(links);

    btn.addEventListener('click', (e) => {
      e.preventDefault();

      if(panel.classList.contains('open')) {
        btn.classList.remove('open');
        panel.style.maxHeight = '';
        panel.classList.remove('open');
        panel.setAttribute('aria-hidden', 'true');
        disableLinks(links);
        parent.dispatchEvent(new CustomEvent('close', { bubbles: true}));
      } else if(panel) {
        btn.classList.add('open');
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        panel.classList.add('open');
        panel.removeAttribute('aria-hidden');
        enableLinks(links);
        parent.dispatchEvent(new CustomEvent('open', { bubbles: true}));
      }
    })
  })
})

// Accordion mobile, tabs desktop

document.addEventListener('DOMContentLoaded', () => {

  const tabbedModules = document.querySelectorAll('.js-tabs');

  tabbedModules.forEach(module => {
    let tabToggles = module.querySelectorAll('.js-tab-toggle');
    let accordionToggles = module.querySelectorAll('.js-tabs-accordion-toggle');
    let panels = module.querySelectorAll('.js-tab-panel');

    let layout = getLayout();

    panels.forEach(panel => {
      const nestedAccordions = panel.querySelectorAll('.js-accordion-item');

      nestedAccordions.forEach(item => {
        let accordionPanel = item.querySelector('.js-accordion-panel');


        item.addEventListener('open', () => {
          if(getLayout() == 'accordion') {
            let panelHeight = parseInt(panel.style.maxHeight, 10);
            panel.style.maxHeight = `${panelHeight + accordionPanel.scrollHeight}px`;
          }
        })
        item.addEventListener('close', () => {
          if(getLayout() == 'accordion') {
            let panelHeight = parseInt(panel.style.maxHeight, 10);
            panel.style.maxHeight = `${panelHeight - accordionPanel.scrollHeight}px`;
          }
        })
      })
    })

    initTabs();

    // window.matchMedia(`(min-width: ${navBp}px)`).matches

    tabToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        let id = toggle.getAttribute('href')
        openTab(id);
      })
    })

    accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        let id = toggle.dataset.tab;
        
        if(toggle.getAttribute('aria-selected') == 'true') {
          closeAccordion(id);
        } else {
          openAccordion(id);
        }
      })
    })

    function openAccordion(id) {
      let panel = module.querySelector(`.js-tab-panel#${id}`);
      let toggle = module.querySelector(`.js-tabs-accordion-toggle[data-tab="${id}"]`);
      
      if(getLayout() == 'accordion') {
        toggle.setAttribute('aria-selected', 'true')
        panel.removeAttribute('aria-hidden')

        setTimeout(() => {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        }, 500);
      }
    }

    function closeAccordion(id) {
      let panel = module.querySelector(`.js-tab-panel#${id}`);
      let toggle = module.querySelector(`.js-tabs-accordion-toggle[data-tab="${id}"]`);

      toggle.setAttribute('aria-selected', 'false')
      panel.style.maxHeight = '';
      panel.setAttribute('aria-hidden');
    }

    function openTab(id) {
      let panel = module.querySelector(`.js-tab-panel${id}`);
      let toggle = module.querySelector(`.js-tab-toggle[href="${id}"]`);

      tabToggles.forEach(item => {
        item.setAttribute('aria-selected', 'false');
      })
      panels.forEach(panel => {
        panel.setAttribute('aria-hidden', 'true');
      })

      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-selected', 'true');
    }

    function initTabs() {
      if(getLayout() == 'tabs') {
        openTab(`#${panels[0].id}`)
      } else {
        openAccordion(panels[0].id)
      }
    }

    function getLayout() {
      if(window.matchMedia(`(min-width: 768px)`).matches) {
        return 'tabs';
      } else {
        return 'accordion';
      }
    }

    function resetTabs() {

      accordionToggles.forEach(item => {
        item.setAttribute('aria-selected', 'false');
      })
      tabToggles.forEach(item => {
        item.setAttribute('aria-selected', 'false');
      })
      panels.forEach(panel => {
        panel.setAttribute('aria-hidden', 'true');
        panel.style.maxHeight = '';
      })

      layout = getLayout();

      if(layout == 'tabs') {
        openTab(`#${panels[0].id}`)
      } else {
        openAccordion(panels[0].id)
      }
    }

    window.addEventListener('resize', () => {
      if(getLayout() != layout) {
        resetTabs();
      }
    });
  })
})


// HH Modals

let targetElement;

const firstScriptTag = document.getElementsByTagName('script')[0];
const videos = $('.js-modal[data-video]');

let youtubePlayers = [];
let vimeoPlayers = [];

let youtube = [];
let vimeo = [];

videos.each((index, modal) => {
  const type = modal.dataset.type;

  if(type == 'youtube') {
    youtube.push(modal)
  } else if (type == 'vimeo') {
    vimeo.push(modal)
  }
})

if (youtube.length) {
  const youtubeTag = document.createElement('script');
  youtubeTag.src = 'https://www.youtube.com/player_api';
  firstScriptTag.parentNode.insertBefore(youtubeTag, firstScriptTag);
}

if (vimeo.length) {
  const vimeoTag = document.createElement('script');
  vimeoTag.src = 'https://player.vimeo.com/api/player.js';
  vimeoTag.onload = onVimeoReadyCallback;
  firstScriptTag.parentNode.insertBefore(vimeoTag, firstScriptTag);
}

window.onYouTubeIframeAPIReady = function () {
  if (youtube.length) {
    const modals = youtube;

    $(modals).each(function () {
      const id = $(this).data('modal');

      const video = $(this).data('video');

      const player = this.querySelector('iframe');

      youtubePlayers[id] = new YT.Player(player, {
        height: '390',
        width: '640',
        videoId: video,
        origin: window.location,
        events: {
          onReady: onPlayerReady(),
        },
      });
    });
  }
};

function onVimeoReadyCallback() {
  const modals = vimeo;

  $(modals).each(function () {
    const id = $(this).data('modal');
    const iframe = this.querySelector('iframe');

    vimeoPlayers[id] = new Vimeo.Player(iframe);
  });
}

function resizeModalVideo() {
  videos.each(function () {
    const modalHeight = $(this).innerHeight() - (parseInt($(this).css('padding-top')) * 2);
    const modalWidth = $(this).innerWidth() - (parseInt($(this).css('padding-left')) * 2);
    const viewSizeRatio = modalHeight / modalWidth;
    const videoRatio = 9 / 16;
    const width = modalHeight / (9 / 16);

    if (videoRatio >= viewSizeRatio) {
      $(this).find('.js-modal-video').css('width', `${width}px`); // set width based on height
    } else {
      $(this).find('.js-modal-video').css('width', '');
    }
  });
}

function resizeModalModel() {
  $('.modal--model').each(function () {
    const modalHeight = $(this).innerHeight() - (parseInt($(this).css('padding-top')) * 2);
    const modalWidth = $(this).innerWidth() - (parseInt($(this).css('padding-left')) * 2);
    const viewSizeRatio = modalHeight / modalWidth;
    const videoRatio = 1;
    const width = modalHeight;

    if (videoRatio >= viewSizeRatio) {
      $(this).find('.modal__content').css('width', `${width}px`); // set width based on height
      $(this).find('.modal__content').css('height', '');
    } else {
      $(this).find('.modal__content').css('width', '');
      $(this).find('.modal__content').css('height', `${modalWidth}px`);
    }
  });
}

$(() => {
    let origFocus;
    let pageBtns;

    $('.js-modal-btn').on('click', function (e) {
      e.preventDefault();
      origFocus = e.target;

      const modalName = $(this).data('modal');

      openModal(modalName);
    });

    $('.js-modal-close').on('click', function (e) {
      e.preventDefault();
      const modal = $(this).parents('.js-modal');
      closeModal(modal);
    });

    // close modal when clicking on overlay
    $('.js-modal').on('click', (e) => {
      // make sure click is on 'background'
      if (!$(e.target).closest('.modal__content').length) {
        closeModal(e.target);
      }
    });

    /* close modal if clicking ESC */
    $(document).on('keyup', (e) => {
      if (e.keyCode == 27) {
        e.preventDefault();
        const modal = $('.modal--is-visible');
        closeModal(modal);
      }
    });

    function openModal(modalName) {
      const modal = $(`.js-modal[data-modal="${modalName}"]`);
      // disable scrolling everywhere except modal content
      targetElement = document.querySelector(`.js-modal[data-modal='${modalName}'] .modal__content`);

      let tableWrapper = document.querySelector(`.js-modal[data-modal='${modalName}'] .table-wrapper`);

      if(tableWrapper) {
        targetElement = tableWrapper;
      }
      if(bodyScrollLock){
        bodyScrollLock.disableBodyScroll(targetElement);
      }

      // show the modal
      $(modal).addClass('modal--is-visible ').attr('aria-hidden', false);

      // set tabindex of all clickable elements outside modal to -1
      pageBtns = $('body').find('select:not([tabindex="-1"]), input:not([tabindex="-1"]), textarea:not([tabindex="-1"]), button:not([tabindex="-1"]), a:not([tabindex="-1"]), iframe:not([tabindex="-1"])');
      $(pageBtns).attr('tabindex', '-1');

      // set tabindex of modal clickable elements to 0
      const modalLinks = $(modal).find('select, input, textarea, button, a, iframe');
      $(modalLinks).attr('tabindex', '0');
      modalLinks.first().focus();

      if (youtubePlayers[modalName]) {
        // var fn = function(){ youtubePlayers[modalName].playVideo(); }
        // setTimeout(fn, 1000);
        youtubePlayers[modalName].playVideo();
      }

      if (vimeoPlayers[modalName]) {
        vimeoPlayers[modalName].play();
      }

      // Handle HTML5 videos with js-play-on-modal-open class
      const html5Videos = modal.find('video.js-play-on-modal-open');
      if (html5Videos.length > 0) {
        html5Videos.each(function() {
          const video = this;
          video.muted = false;
          video.volume = 1.0;
          setTimeout(() => {
            video.play().catch(error => {
              console.warn('Could not autoplay HTML5 video:', error);
            });
          }, 200);
        });
      }

      // Emit modal open event
      modal[0].dispatchEvent(new CustomEvent('open', { bubbles: true, detail: { modal: modalName } }));
    }

    function closeModal(modal) {
      if(bodyScrollLock){
        bodyScrollLock.clearAllBodyScrollLocks();
      }
      

      if (youtubePlayers[$(modal).data('modal')]) {
        youtubePlayers[$(modal).data('modal')].pauseVideo();
        youtubePlayers[$(modal).data('modal')].seekTo(0);
      }

      if (vimeoPlayers[$(modal).data('modal')]) {
        vimeoPlayers[$(modal).data('modal')].pause();
        vimeoPlayers[$(modal).data('modal')].setCurrentTime(0);
      }

      // Handle HTML5 videos with js-play-on-modal-open class
      const html5Videos = $(modal).find('video.js-play-on-modal-open');
      if (html5Videos.length > 0) {
        html5Videos.each(function() {
          const video = this;
          video.pause();
          video.currentTime = 0;
        });
      }

      // hide the modal
      $(modal).removeClass('modal--is-visible ').attr('aria-hidden', true);

      // set tabindex of page elements back to 0
      $(pageBtns).attr('tabindex', '0');

      // set tabindex of modal elements back to -1
      const modalLinks = $(modal).find('select, input, textarea, button, a, iframe');
      $(modalLinks).attr('tabindex', '-1');

      // move focus back to original focus before modal opened
      if (origFocus) {
        origFocus.focus();
      }
    }

    if ($('.js-modal-video').length) {
      resizeModalVideo();
      window.addEventListener('resize', resizeModalVideo);
    }

    if($('.modal--model').length) {
      resizeModalModel();
      window.addEventListener('resize', resizeModalModel());
    }
})
 
function disableLinks(links) {
  links.forEach(link => {
    link.setAttribute('tabindex', '-1');
  })
}

function enableLinks(links) {
  links.forEach(link => {
    link.setAttribute('tabindex', '0');
  })
}

function setupShopifyXr(){
  if (!window.ShopifyXR) {
    document.addEventListener('shopify_xr_initialized', function() {
      setupShopifyXr();
    });
  }else{
    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
    window.ShopifyXR.addModels([JSON.parse(modelJSON.textContent)]);
    modelJSON.remove();
  });
    window.ShopifyXR.setupXRElements();
  }
}

window.Shopify.loadFeatures([
  {
    name: 'shopify-xr',
    version: '1.0',
    onLoad: setupShopifyXr
  }
]);


document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-quick-add-to-cart').forEach(function(button) {
      button.addEventListener('click', function() {
          var variantId = this.getAttribute('data-variant-id');
          var sellingPlanId = this.getAttribute('data-selling-plan-id');

          var requestBody = {
              items: [{
                  id: variantId,
                  quantity: 1
              }]
          };

          // Include the selling plan ID if present
          if (sellingPlanId) {
              requestBody.items[0].selling_plan = sellingPlanId;
          }

          fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(requestBody)
          })
          .then(response => response.json())  
          .then(data => {
              console.log('Product added to cart', data);
          })
          .catch(error => {
              console.error('Error adding product to cart:', error);
          });
      });
  });

  document.querySelectorAll(".js-feature-card").forEach((card) => {
    card.addEventListener("click", (event) => {
      if (event.target.closest(".js-flip-toggle")) {
        const flippedCard = document.querySelector(".js-feature-card.is-flipped");
        
        // Remove "is-flipped" from the previously flipped card if it's not the same as the clicked card
        if (flippedCard && flippedCard !== card) {
          flippedCard.classList.remove("is-flipped");
        }

        // Toggle the class on the clicked card
        card.classList.toggle("is-flipped");
      }
    });
  });


  document.querySelectorAll('.js-features-gallery').forEach((elem) => {
    const slider = new Flickity(elem, {
      cellSelector: '.js-slide',
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false
    })

    const parentContainer = elem.parentNode; 
    const prevButton = parentContainer?.querySelector('.js-prev');
    const nextButton = parentContainer?.querySelector('.js-next');

    if (prevButton && nextButton) {
      prevButton.addEventListener('click', () => slider.previous());
      nextButton.addEventListener('click', () => slider.next());
    }

    slider.on('change', () => {
      document.querySelectorAll(".js-feature-card").forEach((card) => {
        card.classList.remove('is-flipped')
      });
    })

    slider.on('dragStart', () => slider.slider.style.pointerEvents = 'none');
    slider.on('dragEnd', () => slider.slider.style.pointerEvents = 'auto');
  })

  document.querySelectorAll('.js-hotspot-module').forEach((elem) => {
    const sliderElem = elem.querySelector('.js-hotspot-slider');
    const hotspots = elem.querySelectorAll('.js-hotspot');
    const pageDots = elem.querySelectorAll('.js-page-dot');

    const slider = new Flickity(sliderElem, {
      cellSelector: '.js-slide', 
      fade: true,
      prevNextButtons: false,
      pageDots: false
    })

    function updateActiveState(index) {
      hotspots.forEach((btn) => btn.setAttribute('aria-pressed', 'false'));
      pageDots.forEach((btn) => btn.setAttribute('aria-pressed', 'false'));

      if (hotspots[index]) hotspots[index].setAttribute('aria-pressed', 'true');
      if (pageDots[index]) pageDots[index].setAttribute('aria-pressed', 'true');
    }

    hotspots.forEach((hotspot, index) => {
      hotspot.addEventListener('click', () => {
        slider.select(index);
        updateActiveState(index);
      });
    });

    pageDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        slider.select(index);
        updateActiveState(index);
      });
    });

    // Listen for slide change events
    slider.on('change', (index) => {
      updateActiveState(index);
    });
  })
});

document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
}); 